
/*
|
|--------------------------------------------------------------------------
| Barba Reload Scripts
|--------------------------------------------------------------------------
| Wordpress plugins often make use of scripts that need to run when
| specific pages are loaded. The script below runs all js files
| in wp_footer that is not in barbaNoReloadScripts
|
*/
//--------------------------------------------------------------------------
// Add js file names that you do not want to re run on page load
//--------------------------------------------------------------------------
let barbaNoReloadScripts = [
    'mainSrc.min.js',
    'main.min.js',
];

let lowPriorityScripts = [
    'stripe.js',
    'stripe.min.js',
    'stripe-payment-request.js',
    'stripe-payment-request.min.js',
];
//--------------------------------------------------------------------------
// On first page load, add inline scripts to inline-scripts container
//--------------------------------------------------------------------------

$( document ).ready(function() {

    // Iterate through each <script> tag
    $('script').each(function(){

        let scriptSrc = $(this).attr('src');

        // If script does not have src it is an inline script
        if(!scriptSrc){
            $(this).appendTo(".inline-scripts");
        }

    });

});

//------------------------------------------------------------------------------
// Grab raw HTML and process <script> elements before it's added to the page
//------------------------------------------------------------------------------

Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container,newPageRawHTML) {

    //TODO: only make changes to new page html. Don't edit the old.
    let element = $(newPageRawHTML);
    let scriptsToLoadLater = [];
    let mainScriptPromises = [];


    //Clear all inline scripts so we can load new data
    $( ".inline-scripts" ).empty();
    $('footer ~ iframe').remove(); // Remove Stripe Iframe

    // Iterate through each <script> tag
    element.find('.wpFooter script').each(function(){

        let scriptSrc = $(this).attr('src');

        // if script has src then it's not an inline script
        if (scriptSrc) {

            let fileName = scriptSrc.replace(/^.*\//, ''); //Remove everything before file name
            fileName = fileName.replace(/\?.*/, ''); //Remove ? in case a version number is used

            //Run any script that is not included in the barbaNoReloadScripts array
            if ( barbaNoReloadScripts.indexOf(fileName) < 0) {
                if (lowPriorityScripts.includes(fileName)) {
                    scriptsToLoadLater.push(scriptSrc);
                }
                else {
                    mainScriptPromises.push($.getScript(scriptSrc).then(()=>{},()=> {}));
                }
            }

        } else if(!scriptSrc){
            // Append inline scripts to the .inline-scripts container
            $(this).appendTo(".inline-scripts");
        }

    });

    Promise.all(mainScriptPromises).then(() => {
        scriptsToLoadLater.forEach((scriptSrc) => {
            $.getScript(scriptSrc);
        });
    });

});